/**
* @see /client/containers/RestaurantsList/index.js
* RestaurantListCard
*
*/

import React from 'react';
import Styled from 'styled-components';
import PropTypes from 'prop-types';
import RestaurantMainDetails from '../../containers/RestaurantDetails/RestaurantMainDetails';
import Button from '../Button';
import endPoints from '../../config/endPoints';

const RestaurantListcard = Styled.div`
cursor: pointer;
  background:${(props) => props.theme.whiteColor};
  display:inline-block;
  width:100%;
  padding:10px;
  margin-bottom:20px;
  font-size:14px;
    .left{
      float:left;
      width:25%;
      overflow:hidden;
        &:hover {
          img{
            // -webkit-transform: scale(1.3);
            // transform: scale(1.3);
          }
        }
    img{
      width:100%;
      display:block;
      // -webkit-transform: scale(1);
      // transform: scale(1);
      // -webkit-transition: .3s ease-in-out;
      // transition: .3s ease-in-out;
      height: 120px;
      border-radius:5px;
      @media (max-width: ${({ theme: { breakpoints } }) => breakpoints[2]}) {
        height: 115px;
        };
    }

  }
  .center{
    margin-top:10px;
    span{
      padding: 7px 10px;
      background: ${(props) => props.theme.whiteColor};
      width: 74%;
      @media (max-width: ${({ theme: { breakpoints } }) => breakpoints[2]}) {
        width: 100%;
        text-align:center;
        font-weight:600;
      };
      border: ${(props) => props.theme.lightGray} solid 1px;
      display: block;
      text-align: left;
      float: left;
      font-weight: bold;
      small{
        width:70%;
        text-overflow: ellipsis;
        white-space: nowrap;
        overflow: hidden;
        font-size:14px;
        display:inline-block;
      }
      b{
        float:right;
        font-weight:normal;
        color:#717070;
        @media (max-width: ${({ theme: { breakpoints } }) => breakpoints[2]}) {
          width: 100%;
          margin-top: 10px;
        };
      }
    }
    button{
     padding:11px;
     margin:0 0 0 12px;
     text-align:center;
     font-weight:bold;
     background:${(props) => props.theme.primaryColor};
     color:${(props) => props.theme.whiteColor};
     width:24%;
     border:none; 
     @media (max-width: ${({ theme: { breakpoints } }) => breakpoints[2]}) {
      width: 100%;
      margin-left:0px;
      margin-top: 10px;
      border-radius:5px;
    };
    }
  }  
`;

/**
 * @property tags under the {RestaurantMainDetails} does not have tags in the API {*group dinning}
 */
function RestaurantListCard(props) {
  const { merchant_image, rating, cost_for_two, merchant_name, location, cuisines, cashback_deals, group_deals_data, onBookDealClick, merchant_id } = props;
  return (
    <RestaurantListcard onClick={() => onBookDealClick(merchant_id, merchant_name)}>
      <div className="left">
        <img src={`${endPoints.MERCHANT_IMAGE}/${merchant_image}`} alt="" />
      </div>
      <RestaurantMainDetails
        restaurantName={merchant_name}
        restaurantArea={location}
        rating={rating}
        cuisines={cuisines}
        cost={cost_for_two}
        cashBack={cashback_deals}
        onClick={onBookDealClick}
        merchant_id={merchant_id}
      />
      <br clear="all" />
      <div className="center">
        <span>
          <small>{group_deals_data && group_deals_data.length ? group_deals_data[0].deal_title : ''}</small>
          <b>View all deals ({group_deals_data.length})</b>
        </span>
        <Button>Book a Deal</Button>
      </div>
    </RestaurantListcard>
  );
}

RestaurantListcard.defaultProps = {
  tags: [],
};

RestaurantListCard.propTypes = {
  merchant_image: PropTypes.string,
  cuisines: PropTypes.array,
  rating: PropTypes.string,
  cost_for_two: PropTypes.number,
  merchant_name: PropTypes.string,
  location: PropTypes.string,
  cashback_deals: PropTypes.string,
  group_deals_data: PropTypes.array,
  onBookDealClick: PropTypes.func,
  merchant_id: PropTypes.string,
};

export default RestaurantListCard;



// WEBPACK FOOTER //
// client/components/RestaurantListCard/index.js